import Vue from 'vue'
import Router from 'vue-router'

import home from '@/components/home'
import brand from '@/components/brand'
import benifit from '@/components/benifit'
import service from '@/components/service'
import shop from '@/components/shop'
import s1 from '@/components/s1'
import s2 from '@/components/s2'
import s3 from '@/components/s3'
import s4 from '@/components/s4'
import s5 from '@/components/s5'
import blog from '@/components/blog'
import contact from '@/components/contact'
import blogDetail from '@/components/blog/blog-detail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/brand',
      name: 'brand',
      component: brand
    },
    {
      path: '/benifit',
      name: 'benifit',
      component: benifit
    },
    {
      path: '/service',
      name: 'service',
      component: service,
      redirect: '/service/s1',
      children: [
        {
          path: 's1',
          name: 's1',
          component: s1
        },
        {
          path: 's2',
          name: 's2',
          component: s2
        },
        {
          path: 's3',
          name: 's3',
          component: s3
        },
        {
          path: 's4',
          name: 's4',
          component: s4
        },
        {
          path: 's5',
          name: 's5',
          component: s5
        }
      ]
    },
    {
      path: '/shop',
      name: 'shop',
      component: shop
    },
    {
      path: '/blog',
      name: 'blog',
      component: blog
    },
    {
      path: '/blogDetail/:id',
      name: 'blogDetail',
      component: blogDetail
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js